// News content
export const newsData = [
    {
        title: 'Smile Academy new treatment planning software | Video tutorial',
        description: 'Our new treatment planning software is here — watch the video tutorial to see it in action.',
        content: `**New treatment planning software – video tutorial**

Click on the following link to see how to **create a new case** on the Smile Academy portal and also discover how our new **treatment planning software** works.

[Watch the video tutorial](https://www.youtube.com/watch?v=_dtIqoCt4SE)

If you have any questions, please contact us at [info@smile-academy.com.au](mailto:info@smile-academy.com.au)`,
    },
    {
        title: 'Smile Academy 2026 pricing now available',
        description:
            'We are pleased to announce that our 2026 pricing is now live in the Smile Academy portal. All new clear aligner cases now include unlimited free refinements.',
        content: `**IMPORTANT MESSAGE**

We are pleased to announce that our **2026 pricing** is now live in the Smile Academy portal.

All new clear aligner cases now include **unlimited free refinements**, giving you maximum flexibility and confidence throughout treatment.

You can view and download the updated Pricing via the link in the left-hand menu.

If you have any questions or experience any difficulty accessing the document, please contact us at [info@smile-academy.com.au](mailto:info@smile-academy.com.au)

Thank you for your continued trust in Smile Academy.`,
    },
];
